export const isIOS = () => {
  if (typeof navigator === 'undefined') return false;

  // Handles iPhone, iPad, and iPod
  const iOsPattern = /iPad|iPhone|iPod/.test(navigator.platform);

  // Handles iPad on iPadOS 13+ which masks as a Mac
  const isIpadOnNewerOs =
    navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

  return iOsPattern || isIpadOnNewerOs;
};
